<template>
  <side-bar
    v-show="isSidebarActiveLocal"
    position-right
    class="z99-5 max-w25 hrcydivwfull"
  >
    <div class="flex sidebar-topfixpart bg-primary justify-between p-4">
      <h2 class="h2-class font-semibold text-white">ADD MEMBERS</h2>

      <feather-icon
        icon="XIcon"
        @click="isSidebarActiveLocal = false"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
    </div>
    <div class="scroll-85vh cust-overflow-y5 mx-2">
      <div class="">
        <b-list-group flush class="overflow-x-hidden" v-if="members.length > 0">
          <b-list-group-item
            action
            v-for="(member, index) in members"
            :key="'member-' + index"
            class="cursor-pointer py-3"
          >
            <b-row align-v="center">
              <!-- <b-col md="auto" class="pl-2"> -->
              <!-- TODO: Dynamic user image -->
              <!-- <b-avatar variant="primary" class="p-3 ht1em avatar"></b-avatar> -->
              <!-- <img :src=""/> -->

              <!-- 
              <b-col class="pl-3 pr-0">
                <div
                  class="d-flex justify-content-between align-items-center"
                ></div>
              </b-col> -->
              <b-col class="flex w-full">
                <b-form-checkbox
                  v-model="member.isSelected"
                  name="checkbox-1"
                  :value="true"
                  class="colset"
                >
                  <!-- <b-avatar
                    variant="info"
                    class="p-3 ml-2 cust-avatar"
                  ></b-avatar> -->
                  <div>
                    <h4 class="mb-0 text-sm font-semibold">
                      {{ member.firstname }} {{ member.lastname }}
                    </h4>
                  </div>
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-list-group-item>
        </b-list-group>
        <h4
          class="mb-0 py-6 px-3 text-xl font-semibold"
          v-if="members.length == 0"
        >
          No Data
        </h4>
      </div>
    </div>
    <footer class="p-4 w-full mobile-sidebarfooter mb-10">
      <base-button
        block
        type="primary"
        class="rounded font-semibold"
        :disabled="!selectedMembers.length"
        @click.stop="handleAdd"
        >ADD</base-button
      >
    </footer>
  </side-bar>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      members: [],
    };
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.getMembers();
      }
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.members = [];
          this.$emit("closeSidebar");
        }
      },
    },
    ...mapState("channel", {
      channel: "selectedChannel",
    }),
    selectedMembers() {
      return this.members.filter((x) => x.isSelected);
    },
    selectedMembersIDs() {
      return this.selectedMembers.map((x) => x.id);
    },
  },
  methods: {
    async getMembers() {
      const payload = {
        channelID: this.channel._id,
      };
      let loader = this.$loading();
      try {
        const { data } = await this.$store.dispatch(
          "channel/getNonMembers",
          payload
        );
        this.members = data.map((x) => ({ ...x, isSelected: false }));
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async handleAdd() {
      const payload = {
        channelID: this.channel._id,
        UserID: this.selectedMembersIDs,
      };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("channel/addMember", payload);
        this.$swal("", "Successfully Added Members", "success");
        this.isSidebarActiveLocal = false;
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
  },
};
</script>
